'use client';

import Link from 'next/link';

export default function Footer() {
  return (
    <footer className="bg-white rounded-t-lg shadow-sm mt-auto w-full">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-8 border-t">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="space-y-4">
            <h3 className="text-lg font-semibold text-gray-800">Unit Converter</h3>
            <p className="text-sm text-gray-600">
              Your go-to tool for fast and accurate unit conversions.
            </p>
          </div>
          <div className="space-y-2">
            <h4 className="text-sm font-semibold text-gray-800">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link href="/about" className="text-sm text-gray-600 hover:text-emerald-600 transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link href="/terms" className="text-sm text-gray-600 hover:text-emerald-600 transition-colors">
                  Terms of Use
                </Link>
              </li>
              <li>
                <Link href="/privacy" className="text-sm text-gray-600 hover:text-emerald-600 transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link href="/contact" className="text-sm text-gray-600 hover:text-emerald-600 transition-colors">
                  Contact Us
                </Link>
              </li>
              <li>
                <Link href="/sitemap" className="text-sm text-gray-600 hover:text-emerald-600 transition-colors">
                  Sitemap
                </Link>
              </li>
              <li>
                <Link href="/disclaimer" className="text-sm text-gray-600 hover:text-emerald-600 transition-colors">
                  Disclaimer
                </Link>
              </li>
            </ul>
          </div>
          <div className="space-y-2">
            <h4 className="text-sm font-semibold text-gray-800">Popular Converters</h4>
            <ul className="space-y-2">
              <li>
                <Link href="/common-converters/length-converter/" className="text-sm text-gray-600 hover:text-emerald-600 transition-colors">
                  Length
                </Link>
              </li>
              <li>
                <Link href="/common-converters/weight-and-mass-converter/" className="text-sm text-gray-600 hover:text-emerald-600 transition-colors">
                  Weight
                </Link>
              </li>
              <li>
                <Link href="/common-converters/temperature-converter/" className="text-sm text-gray-600 hover:text-emerald-600 transition-colors">
                  Temperature
                </Link>
              </li>
              <li>
                <Link href="/common-converters/area-converter/" className="text-sm text-gray-600 hover:text-emerald-600 transition-colors">
                  Area
                </Link>
              </li>
              <li>
                <Link href="/common-converters/volume-converter/" className="text-sm text-gray-600 hover:text-emerald-600 transition-colors">
                  Volume
                </Link>
              </li>
              <li>
                <Link href="/common-converters/time-converter/" className="text-sm text-gray-600 hover:text-emerald-600 transition-colors">
                  Time
                </Link>
              </li>
            </ul>
          </div>
          <div className="space-y-2">
            <h4 className="text-sm font-semibold text-gray-800">Contact</h4>
            <p className="text-sm text-gray-600">
              Have questions?<br />
              Email us at: support@allunitconverter.com
            </p>
          </div>
        </div>
        <div className="border-t border-gray-200 mt-6 pt-6 text-center">
          <p className="text-sm text-gray-600">
            © {new Date().getFullYear()} Unit Converter. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
